const spscrollable = () => {
  if (window.innerWidth > 767) return;
  const scrollables = document.querySelectorAll('.js-sp-scrollable');

  if (scrollables.length <= 0) return;

  scrollables.forEach(element => {
    //@ts-ignore
    new ScrollHint(element,
      {
        suggestiveShadow: true,
        i18n: {
          scrollable: 'スクロールできます'
        }
      }
    );
  });
};

export default spscrollable;
